import { useEliteReservation } from "@/contexts/EliteTemporaryContextProvider";
import { ThemeProvider } from "@/providers/ThemeProvider";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { GlobalAlertDialog } from "./GlobalAlertDialog";
import Navbar from "./Navbar";
import { Button } from "./ui/button";

export interface LayoutProps {
  children?: React.ReactNode;
}

export default function AppLayout({ children }: LayoutProps) {
  const { fromKiosk, reservation } = useEliteReservation();

  return (
    <div className="min-h-screen bg-background">
      <ThemeProvider>
        <Navbar />
        <div className="container mx-auto max-w-6xl">
          {fromKiosk && (
            <div className="px-4 pt-4">
              <Link to={`${reservation?.structure?.id}/kiosk`}>
                <Button
                  variant="secondary"
                  className="text-md"
                  size="lg"
                >
                  <ArrowLeft className="mr-2 h-4 w-4" />
                  Torna indietro
                </Button>
              </Link>
            </div>
          )}

          <main className="p-4 md:p-8">
            {children}
          </main>
          <GlobalAlertDialog />
        </div>
      </ThemeProvider>
    </div>
  );
}
